/* Guarded so more than one section can load this file on the same page:
   a repeated top-level `class` declaration is a SyntaxError. */
if (!customElements.get("component-details-modal")) {
class ComponentDetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    // Popups with no input (the hydration info popups, the PDP ingredient
    // modal) passed null here, and trapFocus only defaults an undefined
    // argument, so it threw on null.focus() and skipped the line below. Fall
    // back to the panel itself.
    const panel = this.detailsContainer.querySelector('[tabindex="-1"]');
    trapFocus(
      panel,
      this.detailsContainer.querySelector('input:not([type="hidden"])') || panel
    );

    requestAnimationFrame(() => {
      this.detailsContainer.classList.add("opening");
    });
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
    this.detailsContainer.classList.remove("opening");
    const handleTransitionEnd = () => {
      this.detailsContainer.removeAttribute("open");
    };
    this.detailsContainer.addEventListener(
      "transitionend",
      handleTransitionEnd,
      { once: true }
    );
    setTimeout(() => {
      handleTransitionEnd();
      this.detailsContainer.removeEventListener(
        "transitionend",
        handleTransitionEnd
      );
    }, 150);
  }
}

customElements.define("component-details-modal", ComponentDetailsModal);
}
